import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import UnpublishedIcon from "@mui/icons-material/Unpublished";
import { CircularProgress, Grid, styled, TableCell, tableCellClasses, TableRow, Tooltip, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RcsDeliveredIcon from "../../../assets/icons/rcs-delivered-icon";
import RcsReadIcon from "../../../assets/icons/rcs-read-icon";
import RcsSentIcon from "../../../assets/icons/rcs-sent-icon";
import { setApiBotStatusReport, setApiBotStatusReportLoading } from '../../../redux/apiReportManagement/apiReportManagementSlice';
import { apiGatewayAxiosInstance } from '../../../utils/axios';

import { tooltipClasses } from '@mui/joy';
import moment from 'moment/moment';
import { setErroMessageForField } from "../../../redux/campaignManagment/campaignManagmentSlice";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: "14px !important",
        fontWeight: "bold",
        backgroundColor: "#f4f4f4",
        padding: "5px 15px !important",
        // color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: "13px !important",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // "&:nth-of-type(odd)": {
    //     backgroundColor: theme.palette.action.hover,
    // },

    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

const calculateTime = value => {
    const time = new Date(value).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
    const day = new Date(value).toLocaleDateString([], { day: "2-digit" });
    const month = new Date(value).toLocaleDateString([], { month: "2-digit" });
    const year = new Date(value).toLocaleDateString([], { year: "numeric" });

    return `${day}-${month}-${year} , ${time}`;
};


export const MessageStatusForCount = {
    Failed: 'FAILED',
    Read: 'READ',
    Delivered: 'DELIVERED',
    Sent: 'SENT',
    Retry: 'RETRY',
    Pending: 'PENDING',
    TTLExpirationRevoked: 'TTL_EXPIRATION_REVOKED',
    Sms: 'SMS',
    TotalCount: 'TOTAL_COUNT',
    CampaignLastTime: 'CAMPAIGN_LAST_TIME',
    CampaignFirstTime: 'CAMPAIGN_FIRST_TIME',
    TotalSMSCount: 'TOTAL_SMS',
    TotalRCSCount: 'TOTAL_RCS',
    SmsDELIVERED: 'SMS-DELIVERED',
    TotalSMSFailed: 'TOTAL_SMS_FAILED'

}


export default function SMSAPIReports({ bot, setShowBotReport }) {

    let endDate = dayjs();
    let startDate = dayjs();
    // new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    // endDate = moment(endDate).format('YYYY-MM-DD');
    // startDate = moment(startDate).format("YYYY-MM-DD");
    const [searchParams, setSearchParams] = useState({
        startDate,
        endDate
    });
    // const searchRecipientNumber = useDebounce(searchParams, 1000);
    const [reload, setReload] = useState(true);
    const [error, setError] = useState({ exists: false, message: "" });
    const state = useSelector(state => state.apiReportsManagementSlice)
    const dispatch = useDispatch();
    const botId = bot.config.rbmClientId

    const getApiReportForBot = async (status) => {

        try {
            dispatch(setApiBotStatusReportLoading({ [`${botId}_${status}`]: true }));
            const response = await apiGatewayAxiosInstance.get(`/conversation_logger/api-logger/get-api-reports-by-status-of-bot`, {
                params: {
                    messageStatus: status,
                    templateId: searchParams.templateId,
                    userNumber: searchParams.userNumber,
                    startDate: moment(new Date(searchParams.startDate)).format('YYYY-MM-DD'),
                    endDate: moment(new Date(searchParams.endDate)).format('YYYY-MM-DD'),

                    botId,
                    // sendTime: "",
                    provider: searchParams.provider,
                },
            });


            // dispatch(setApiBotStatusReport(response.data.apiBotReportDetails))
            dispatch(setApiBotStatusReport({ [`${botId}_${status}`]: response.data.apiBotReportDetails[status] }))

        } catch (error) {
            console.log(error)

            dispatch(setApiBotStatusReport({ [`${botId}_${status}`]: "--" }))
        }
        dispatch(setApiBotStatusReportLoading({ [`${botId}_${status}`]: false }));

    }

    useEffect(() => {
        dispatch(setApiBotStatusReport({
            "SENT": 0,
            "SMS": 0,
            "DELIVERED": 0,
            "RETRY": 0,
            "READ": 0,
            "TOTAL_COUNT": 0,
            "PENDING": 0,
            "FAILED": 0,
            "TTL_EXPIRATION_REVOKED": 0
        }))

    }, [])

    useEffect(() => {
        getApiReportForBot(MessageStatusForCount.Pending);
        getApiReportForBot(MessageStatusForCount.Sent);
        getApiReportForBot(MessageStatusForCount.Delivered);
        getApiReportForBot(MessageStatusForCount.Failed);
        getApiReportForBot(MessageStatusForCount.Read);
        getApiReportForBot(MessageStatusForCount.Retry);
        getApiReportForBot(MessageStatusForCount.TotalCount);
        getApiReportForBot(MessageStatusForCount.TTLExpirationRevoked);
        getApiReportForBot(MessageStatusForCount.TotalSMSCount);
        getApiReportForBot(MessageStatusForCount.Sms);
        getApiReportForBot(MessageStatusForCount.SmsDELIVERED);
        getApiReportForBot(MessageStatusForCount.TotalSMSFailed);
    }, [reload])

    return (
        <Grid
            container
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap"
            }}
        >

            <Grid
                item
                md={12}
                sx={{
                    alignItems: "center",
                    justifyContent: "start",
                    flexWrap: "wrap !important"
                }}
                gap={15}
            >
                <Grid>
                    <Typography
                        sx={{
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        TOTAL :   {state.apiBotStatusReportLoading[`${botId}_${MessageStatusForCount.TotalSMSCount}`] ? <CircularProgress sx={{ marginLeft: '.3rem' }} color="inherit" size={15} /> : state.apiBotStatusReport[`${botId}_${MessageStatusForCount.TotalSMSCount}`]}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        color='primary'
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        SENT : {state.apiBotStatusReportLoading[`${botId}_${MessageStatusForCount.Sms}`] ? <CircularProgress sx={{ marginLeft: '.3rem' }} color="inherit" size={15} /> : state.apiBotStatusReport[`${botId}_${MessageStatusForCount.Sms}`]}

                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        color='green'
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        DELIVERED : {state.apiBotStatusReportLoading[`${botId}_${MessageStatusForCount.SmsDELIVERED}`] ? <CircularProgress sx={{ marginLeft: '.3rem' }} color="inherit" size={15} /> : state.apiBotStatusReport[`${botId}_${MessageStatusForCount.SmsDELIVERED}`]}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        color='error'
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        Failed : {state.apiBotStatusReportLoading[`${botId}_${MessageStatusForCount.TotalSMSFailed}`] ? <CircularProgress sx={{ marginLeft: '.3rem' }} color="inherit" size={15} /> : state.apiBotStatusReport[`${botId}_${MessageStatusForCount.TotalSMSFailed}`]}

                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}
